/* eslint-disable */

<template>
  <div>
    <router-view />
    <div class="cookie_button consent-button" style="display: block">
      <!-- <button class="btn-cookie btn-transparent" @click.prevent="oneTrustModal">Meine Cookie Auswahl</button> -->
    </div>
  </div>
</template>
<script>
const version = process.env.VUE_APP_VERSION;

export default {
  created() {
    console.log("%cV" + version, "color:red; font-size:32px;");
  },
};
</script>
<style lang="scss">
@media (min-width: 1440px) {
  .container,
  .container-sm,
  .container-md,
  .container-lg,
  .container-xl {
    max-width: 1150px !important;
  }
}
#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}
@import "node_modules/bootstrap/scss/bootstrap";
@import "node_modules/bootstrap-vue/src/index.scss";
@import "assets/styles/_application.scss";
#app {
  overflow-x: hidden;
  // font-family: "Plus Jakarta Sans", sans-serif !important;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  // text-align: center;
  color: var(--brand-color3);
  height: 100%;
}

a {
  text-decoration: none;
  color: inherit;
  cursor: pointer;
}
.cookie_button button {
  font-size: 14px;
  padding: 10px;
  border-radius: 3px;
  border: 1px solid #034c90;
  right: 0;
}

.cookie_button button:hover {
  color: #034c90;
  background: #fff;
}
.cookie_button {
  border-radius: 3px;
  -webkit-animation-duration: 1s;
  animation-duration: 1s;
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both;
  -webkit-animation-name: fadeIn;
  animation-name: fadeIn;
  text-align: left;
  position: fixed;
  right: 0;
  z-index: 2;
  bottom: 0px;
  opacity: 0.9;
  background: #034c90;
  color: #000000;
  display: none;
  overflow: auto;
}
.cookie_button.open {
  display: block;
}
.btn-cookie {
  font-size: 20px;
  // letter-spacing: 1px;
  color: #081821;
  transition: all 0.3s;
  white-space: normal;
  line-height: 1.36;
  text-align: center;
  padding: 9px 5px 9px;
  // text-transform: uppercase;
  border-radius: 0rem;
  font-family: "BebasNeue", sans-serif;
  border: none;
  line-height: 1;
  @media (max-width: 374px) {
    // font-size: 18px;
  }
  &.disabled {
    opacity: 0.5;
  }
  &-gold {
    padding: 11px 29px 6px;
    background-color: #034c90;
    background: #034c90;
    width: 100%;
    .arrow {
      width: 0;
      height: 0;
      border: 10px solid transparent;
      margin-top: 5px;
      &.arrow-left {
        border-right: 0;
        border-left: 10px solid #ffffff;
        margin-left: 10px;
        float: right;
      }
      &.arrow-right {
        border-left: 0;
        border-right: 10px solid #ffffff;
        margin-right: 10px;
        float: left;
      }
    }
  }
  .btn-transparent {
    background-color: transparent;
    color: #ffffff;
    border-color: #ffffff;
  }
  .btn-transparent:hover,
  .btn-transparent:focus {
    background-color: transparent;
    color: #ffffff;
  }
  &-transparent {
    background-color: transparent;
    color: #ffffff;
    line-height: 1.2;
    .arrow_right {
      float: right;
      padding-left: 15px;
    }
  }
  &-big {
    width: 315px;
    max-width: 100%;
  }
}
.order_priority {
  @media (max-width: 767px) {
    order: 1;
  }
}

.disclaimer {
  font-size: 12px;
  font-weight: 500;
  line-height: 19px;
  color: #12327d;
  // padding: 0 20px 0 20px;
}

@media (max-width: 767px) {
  .hideMobile {
    display: none;
  }
}

.header-wrapper {
  padding-top: 70px;

  @media (max-width: 767px) {
    padding-top: 40px;
  }
}

ul ul {
  list-style-type: disc;
}

.unselectable {
  user-drag: none;
  -webkit-user-drag: none;
  user-select: none;
  -moz-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
}

a {
  &:hover {
    text-decoration: underline !important;
    text-underline-position: under !important;
  }
}
</style>
